import { Component, Input } from '@angular/core';

import { StatusAction, Status } from 'src/app/shared/interfaces/status.interface';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.sass']
})
export class StatusComponent {
  @Input() margin = '0';
  public hasActions = false;
  public visible = false;
  public status: { type: string, text: string, load: boolean, actions: StatusAction[] } = null;

  @Input('status')
  set setStatusInfo(status: Status | null) {
    if (status) {
      this.setStatus(status);
      this.visible = true;
    } else {
      this.hide();
    }
  }

  public setStatus(status: Status): Promise<any> {
    return new Promise((resolve, reject) => {
      const actions = status.actions || [];
      if (status.success) {
        this.status = { text: status.success, type: 'alert-success', load: status.load, actions: actions };
      } else if (status.info) {
        this.status = { text: status.info, type: 'alert-info', load: status.load, actions: actions };
      } else if (status.warning) {
        this.status = { text: status.warning, type: 'alert-warning', load: status.load, actions: actions };
      } else if (status.danger) {
        this.status = { text: status.danger, type: 'alert-danger', load: status.load, actions: actions };
      } else if (status.error) {
        this.status = {
          text: status.error instanceof Error ? status.error.message : status.error,
          type: 'alert-danger',
          load: status.load,
          actions: actions
        };
      } else {
        this.status = null;
        this.visible = false;
        setTimeout(() => resolve(false), 10);
        return;
      }

      this.hasActions = this.status.actions.length > 0;
      this.visible = true;

      if (status.delay > 0) {
        setTimeout(() => {
          this.setStatus({});
        }, status.delay);
      }

      setTimeout(() => resolve(false), 10);
    });
  }

  public get error(): boolean {
    return !this.status ? false : (this.status.type === 'alert-warning' || this.status.type === 'alert-danger');
  }

  public hide(): Promise<any> {
    return this.setStatus({});
  }
}
